<template>
  <ModalCustom
    :model="showModal"
    :title="'修改密码'"
    :ok-text="'保存'"
    @on-ok="submitData"
    @on-cancel="cancelData"
  >
    <Form
      slot="body"
      ref="userDetail"
      :model="userDetailModel"
      :rules="userDetailRules"
      :label-width="95"
      label-position="left"
      :label-colon="true"
    >
      <FormItem label="登录名" prop="userName">
        <Input v-model="userDetailModel.userName" disabled></Input>
      </FormItem>
      <FormItem label="旧密码" prop="oldPassword">
        <Input type="password" password v-model="userDetailModel.oldPassword" placeholder="请输入..."></Input>
      </FormItem>
      <FormItem label="新密码" prop="newPassword">
        <Input type="password" password v-model="userDetailModel.newPassword" placeholder="请输入..."></Input>
      </FormItem>
      <FormItem label="确认密码" prop="confirmPassword">
        <Input type="password" password v-model="userDetailModel.confirmPassword" placeholder="请输入..."></Input>
      </FormItem>
    </Form>
  </ModalCustom>
</template>
<script>
  import MD5 from 'md5.js/index'
  import ModalCustom from '../../components/modal-custom/index'
  import {ajax2} from '@/libs/ajax'
  import {mapMutations} from 'vuex'
  export default {
    name: 'editUserInfo',
    components: { MD5, ModalCustom },
    props: {
      model: {
        type: Boolean,
        default: false
      }
    },
    data () {
      const validatePass1 = (rule, value, callback) => {
        if (this.userDetailModel.confirmPassword) {
          this.$refs['userDetail'].validateField('confirmPassword')
          callback()
        } else {
          callback()
        }
      }
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.userDetailModel.newPassword) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        showModal: false,
        userDetailModel: {
          userName: '',
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        },
        memberId: '',
        userDetailRules: {
          userName: [
            { required: true, message: '用户名必填', trigger: 'blur' }
          ],
          oldPassword: [
            { required: true, message: '旧密码必填', trigger: 'blur' }
          ],
          newPassword: [
            { required: true, message: '新密码必填', trigger: 'blur' },
            { type: 'string', min: 8, message: '密码长度最小为8位', trigger: 'blur' },
            { type: 'string',
              pattern: /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%^&*?,./\-_ ]).*$/,
              message: '密码必须包含大小写字母、数字及特殊字符',
              trigger: 'blur' },
            { required: true, validator: validatePass1, trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: '确认密码必填', trigger: 'blur' },
            { required: true, validator: validatePass2, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      ...mapMutations('user', ['setUser', 'logout']),
      modelChanged (model) {
        this.showModal = model
      },
      cancelData () {
        this.$refs['userDetail'].resetFields()
        this.$emit('cancelEdit')
      },
      submitData () {
        let _this = this
        // 如果id存在就可以认为是更新数据
        this.$refs['userDetail'].validate((valid) => {
          if (valid) {
            let requestParmas = {}
            requestParmas['memberId'] = this.memberId.toString()
            requestParmas['oldPassword'] = new MD5().update(this.userDetailModel.oldPassword.toString()).digest('hex')
            requestParmas['newPassword'] = new MD5().update(this.userDetailModel.newPassword.toString()).digest('hex')
            let jsonStr = JSON.stringify(requestParmas)
            ajax2.post('oba3/api/member/change-pwd', jsonStr).then(response => {
              let result = response.data
              if (result.code === '0000') {
                // success update
                this.$Message.success('更改成功')
                this.cancelData()
                _this.logout(_this)
                _this.$store.dispatch('logout')
                _this.$router.push({
                  name: 'login'
                })
              } else {
                this.$Message.error(result.msg)
              }
            })
          }
        })
      },
      getUserInfo () {
        const storage = window.localStorage
        let userInfo = JSON.parse(storage.getItem('user'))
        this.userDetailModel.userName = userInfo.account.toString()
        this.memberId = userInfo.userId.toString()
      }
    },
    mounted () {},
    watch: {
      model: {
        handler: 'modelChanged',
        immediate: true
      },
      showModal (value) {
        if (value) {
          this.getUserInfo()
        } else {
          this.cancelData()
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../styles/_common/components/index.less";

  .input-class {
    width: 258px;
  }
</style>



// WEBPACK FOOTER //
// src/views/gip/account/editUserInfo.vue